import { Outlet, useParams } from "react-router-dom";
import DocumentList from "./DocumentList";
import DocumentView from "./DocumentView";

export default function ArchiveLayout({ currentLang }) {
  const { docId } = useParams();

  return (
    <div>
      {docId && <Outlet />}

      <DocumentList currentLang={currentLang} className={docId ? 'hidden' : ''} />
    </div>
  );
}
